import axios from "axios";

import mapToSearchObj from "./mapToSearchObj";

class ApiProxyClient {
  instance;

  constructor() {
    this.instance = axios.create({
      baseURL: `${process.env.ATS_URL}/js`,
      headers: {
        "Content-Type": "application/json; charset=utf-8",
        Tenant: process.env.TENANT_ID,
      },
    });
  }

  getVacancies = async (query, options) => {
    const params = {
      order: query?.order || "DESC",
      sortBy: "createdDateTime",
      ...query,
    };

    const searchObj = await mapToSearchObj(params, options);

    try {
      const tenantIds = Array.isArray(query.tenantIds)
        ? query.tenantIds
        : [query.tenantIds].filter(Boolean);
      const tenantIdsToQuery = [process.env.TENANT_ID, ...tenantIds].filter(
        Boolean
      );
      const data = { limit: 5000, ...searchObj };

      console.log("[search] /search/vacancy request", {
        tenantIds: tenantIdsToQuery,
        query: data,
      });

      const responses = await Promise.all(
        tenantIdsToQuery.map((tenantId) =>
          this.instance
            .post("/search/vacancy", data, {
              headers: { Tenant: tenantId },
            })
            .catch((error) => {
              console.error("Error with tenantId:", tenantId, error);
              return null; // return null or a default value for failed request
            })
        )
      );

      const validResponses = responses.filter((response) => response !== null);

      if (validResponses.length === 0) {
        throw new Error("All tenant requests failed");
      }

      const mergedResults = validResponses.reduce(
        (acc, response) => {
          acc.results = [...acc.results, ...(response.data.results || [])];
          acc.totalResults += response.data.totalResults || 0;
          return acc;
        },
        { results: [], totalResults: 0 }
      );

      console.log("[search] /search/vacancy response", {
        totalResults: mergedResults.totalResults,
        returned: mergedResults.results.length,
      });

      return {
        status: 200,
        statusText: "OK",
        headers: validResponses[0].headers,
        config: this.instance.defaults,
        request: {},
        data: mergedResults,
      };
    } catch (error) {
      console.error("Error in getVacancies method:", {
        message: error.message,
        stack: error.stack,
        query,
        options,
      });
      // Re-throw the error or return a custom error response
      throw error;
    }
  };
}

const apiProxy = new ApiProxyClient();
export default apiProxy;
